import React from "react";
import EmployeeList from "./components/EmployeeTable/EmployeeList"; // Ensure this is the correct path
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";

const Employee = ({ user }) => {
  return (
    <NavHeightAdjust>
      <EmployeeList user={user} />
    </NavHeightAdjust>
  );
};

export default Employee;
